// Sticky Add to Cart JavaScript - Synchronized with Main Product Section
(function() {
  'use strict';

  function initStickyAddToCart() {
    const stickyATC = document.querySelector('[data-sticky-add-to-cart]');
    if (!stickyATC) return;

    // Prevent double binding on the same element instance
    if (stickyATC.dataset.initialized === 'true') return;
    stickyATC.dataset.initialized = 'true';

    const productSection = document.querySelector('section-product');
    if (!productSection) return;

    // Find the product form buttons element or fallback to product form
    const productFormButtons = productSection.querySelector('.product-form__buttons') ||
      productSection.querySelector('.product-form__submit') ||
      productSection.querySelector('form[action*="/cart/add"]');
    if (!productFormButtons) return;

    const stickyForm = stickyATC.querySelector('#sticky-product-form');
    const stickySubmitBtn = stickyATC.querySelector('[data-sticky-atc-submit]');
    const stickyVariantId = stickyATC.querySelector('[data-sticky-atc-variant-id]');
    const stickyPrice = stickyATC.querySelector('[data-sticky-atc-price]');
    const stickyQuantity = stickyATC.querySelector('[data-sticky-atc-quantity]');
    const stickyContent = stickyATC.querySelector('[data-sticky-atc-content]') || stickyATC.querySelector('.sticky-add-to-cart__content');
    const mediaGallery = productSection.querySelector('component-product-media-gallery');
    const quickCart = document.querySelector('section-quick-cart');

    // Parse all product variants data from JSON script tag
    let variantsData = [];
    const variantsDataScript = stickyATC.querySelector('[data-sticky-atc-variants-data]');
    if (variantsDataScript) {
      try {
        variantsData = JSON.parse(variantsDataScript.textContent) || [];
      } catch (e) {
        console.warn('Could not parse sticky ATC variants data:', e);
      }
    }

    let isScrolled = false;

    // Helper: format image URL safely
    function formatImageUrl(url, width) {
      if (!url) return '';
      let cleanUrl = url.startsWith('//') ? 'https:' + url : url;
      try {
        const parsed = new URL(cleanUrl, window.location.origin);
        if (width && parsed.hostname.includes('cdn.shopify.com')) {
          parsed.searchParams.set('width', width);
        }
        return parsed.toString();
      } catch (e) {
        return cleanUrl;
      }
    }

    // Dynamic getter for active variant ID
    function getActiveVariantId() {
      // 1. Check main form hidden ID
      const mainHiddenInput = productSection.querySelector('[data-update-hidden-id]') ||
        productSection.querySelector('form[action*="/cart/add"] input[name="id"]');
      if (mainHiddenInput && mainHiddenInput.value) {
        return String(mainHiddenInput.value);
      }

      // 2. Check data-selected-variant script tag
      const selectedVariantScript = productSection.querySelector('[data-selected-variant]');
      if (selectedVariantScript) {
        try {
          const parsed = JSON.parse(selectedVariantScript.textContent);
          if (parsed && parsed.id) return String(parsed.id);
        } catch (e) {}
      }

      // 3. Check URL parameter
      const urlVariant = new URLSearchParams(window.location.search).get('variant');
      if (urlVariant) return String(urlVariant);

      // 4. Fallback to existing sticky variant ID
      return stickyVariantId ? String(stickyVariantId.value) : null;
    }

    // Dynamic getter for active variant object
    function getActiveVariantData(variantOverride) {
      if (variantOverride && typeof variantOverride === 'object') {
        return variantOverride;
      }

      const activeId = getActiveVariantId();

      // Look in variantsData list
      if (activeId && variantsData.length > 0) {
        const found = variantsData.find((v) => String(v.id) === String(activeId));
        if (found) return found;
      }

      // Fallback: look in [data-selected-variant]
      const selectedVariantScript = productSection.querySelector('[data-selected-variant]');
      if (selectedVariantScript) {
        try {
          const parsed = JSON.parse(selectedVariantScript.textContent);
          if (parsed) return parsed;
        } catch (e) {}
      }

      return null;
    }

    // Update sticky image based on variant
    function updateStickyImage(variant) {
      const stickyImage = stickyATC.querySelector('.sticky-add-to-cart__image img');
      if (!stickyImage) return;

      let newSrc = '';
      let newAlt = variant?.title || '';

      // 1. Check featured_image property
      if (variant && variant.featured_image) {
        if (typeof variant.featured_image === 'string') {
          newSrc = variant.featured_image;
        } else if (variant.featured_image.src) {
          newSrc = variant.featured_image.src;
          newAlt = variant.featured_image.alt || newAlt;
        }
      }

      // 2. Check featured_media property
      if (!newSrc && variant && variant.featured_media) {
        if (variant.featured_media.preview_image && variant.featured_media.preview_image.src) {
          newSrc = variant.featured_media.preview_image.src;
          newAlt = variant.featured_media.alt || newAlt;
        } else if (variant.featured_media.src) {
          newSrc = variant.featured_media.src;
        }
      }

      // 3. Check media gallery slide matching variant media ID
      const mediaId = variant?.featured_media?.id || variant?.featured_image?.id;
      if (!newSrc && mediaId && mediaGallery) {
        const matchingMediaImg = mediaGallery.querySelector(`[data-media-id="${mediaId}"] img`);
        if (matchingMediaImg) {
          newSrc = matchingMediaImg.currentSrc || matchingMediaImg.src;
          newAlt = matchingMediaImg.alt || newAlt;
        }
      }

      // 4. Fallback to active swiper slide in gallery
      if (!newSrc && mediaGallery) {
        const activeSlideImg = mediaGallery.querySelector('.swiper-slide-active img, .product__media-item.is-active img');
        if (activeSlideImg) {
          newSrc = activeSlideImg.currentSrc || activeSlideImg.src;
          newAlt = activeSlideImg.alt || newAlt;
        }
      }

      // If we found a valid new image, apply it
      if (newSrc) {
        const formatted80 = formatImageUrl(newSrc, 80);
        const formatted160 = formatImageUrl(newSrc, 160);

        stickyImage.src = formatted80;
        if (formatted160 && formatted160 !== formatted80) {
          stickyImage.srcset = `${formatted80} 80w, ${formatted160} 160w`;
        } else {
          stickyImage.removeAttribute('srcset');
        }

        if (newAlt) {
          stickyImage.alt = newAlt;
        }

        // Remove shimmer placeholder if present
        const shimmerWrapper = stickyImage.closest('.shimmer');
        if (shimmerWrapper) {
          shimmerWrapper.classList.remove('shimmer');
        }
      }
    }

    // Sync price from main product
    function syncPrice(variant) {
      if (!stickyPrice) return;
      const mainPrice = productSection.querySelector('[data-update-price]');
      if (mainPrice && mainPrice.innerHTML.trim() !== '') {
        stickyPrice.innerHTML = mainPrice.innerHTML;
      }
    }

    // Sync quantity selector
    function syncQuantity() {
      if (!stickyQuantity) return;
      const mainQuantityInput = productSection.querySelector('[data-product-quantity-selector] input[name="quantity"]') ||
        productSection.querySelector('form[action*="/cart/add"] input[name="quantity"]');
      const stickyQuantityInput = stickyQuantity.querySelector('input[name="quantity"]');
      if (mainQuantityInput && stickyQuantityInput) {
        stickyQuantityInput.value = mainQuantityInput.value;
      }
    }

    // Update sticky submit button state and label
    function updateStickyButtonState(variant) {
      if (!stickySubmitBtn) return;

      const mainSubmitBtn = productSection.querySelector('.product-form__submit');
      const mainBtnTextEl = mainSubmitBtn?.querySelector('.atc-text') || mainSubmitBtn?.querySelector('span');
      const mainBtnText = (mainBtnTextEl ? mainBtnTextEl.textContent : mainSubmitBtn?.textContent || '').trim();

      const btnSpan = stickySubmitBtn.querySelector('span');
      const activeVariant = variant || getActiveVariantData();

      let isAvailable = true;
      if (activeVariant && typeof activeVariant.available === 'boolean') {
        isAvailable = activeVariant.available;
      } else if (mainSubmitBtn && mainSubmitBtn.hasAttribute('disabled')) {
        isAvailable = false;
      }

      if (!isAvailable || activeVariant === null) {
        stickySubmitBtn.disabled = true;
        if (btnSpan) {
          btnSpan.textContent = activeVariant === null ? 'Unavailable' : (mainBtnText && mainBtnText.toLowerCase().includes('sold') ? mainBtnText : 'Sold out');
        }
      } else {
        stickySubmitBtn.disabled = false;
        if (btnSpan) {
          btnSpan.textContent = mainBtnText || 'Add to cart';
        }
      }
    }

    // Sync line-item properties and selling plans from main form
    function syncFormProperties() {
      if (!stickyForm) return;
      const mainForm = productSection.querySelector('form[action*="/cart/add"]');
      if (!mainForm) return;

      // Sync selling_plan if present (subscriptions)
      const mainSellingPlan = mainForm.querySelector('input[name="selling_plan"]:checked') ||
        mainForm.querySelector('input[name="selling_plan"][type="hidden"]') ||
        mainForm.querySelector('select[name="selling_plan"]');
      if (mainSellingPlan && mainSellingPlan.value) {
        let stickySellingPlan = stickyForm.querySelector('input[name="selling_plan"]');
        if (!stickySellingPlan) {
          stickySellingPlan = document.createElement('input');
          stickySellingPlan.type = 'hidden';
          stickySellingPlan.name = 'selling_plan';
          stickyForm.appendChild(stickySellingPlan);
        }
        stickySellingPlan.value = mainSellingPlan.value;
      } else {
        const stickySellingPlan = stickyForm.querySelector('input[name="selling_plan"]');
        if (stickySellingPlan) stickySellingPlan.remove();
      }

      // Sync custom line item properties (e.g. Pre-order item, gift qty)
      mainForm.querySelectorAll('input[name^="properties["]').forEach((prop) => {
        let stickyProp = stickyForm.querySelector(`input[name="${prop.name}"]`);
        if (!stickyProp) {
          stickyProp = document.createElement('input');
          stickyProp.type = 'hidden';
          stickyProp.name = prop.name;
          stickyForm.appendChild(stickyProp);
        }
        stickyProp.value = prop.value;
      });
    }

    // Comprehensive sync method
    function syncWithMainProduct(variantOverride) {
      const activeId = getActiveVariantId();
      if (stickyVariantId && activeId) {
        stickyVariantId.value = activeId;
      }

      const variantData = getActiveVariantData(variantOverride);
      updateStickyImage(variantData);
      syncPrice(variantData);
      syncQuantity();
      updateStickyButtonState(variantData);
      syncFormProperties();
    }

    // Scroll observer
    function initScrollObserver() {
      const checkScrollPosition = () => {
        const buttonsRect = productFormButtons.getBoundingClientRect();
        const buttonsBottom = buttonsRect.bottom;

        if (buttonsBottom < 0) {
          if (!isScrolled) {
            syncWithMainProduct();
            stickyATC.classList.add('is-visible');
            isScrolled = true;
          }
        } else {
          if (isScrolled) {
            stickyATC.classList.remove('is-visible');
            isScrolled = false;
          }
        }
      };

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            const rect = entry.boundingClientRect;
            if (rect.bottom < 0) {
              if (!isScrolled) {
                syncWithMainProduct();
                stickyATC.classList.add('is-visible');
                isScrolled = true;
              }
            } else if (isScrolled && rect.bottom >= 0) {
              stickyATC.classList.remove('is-visible');
              isScrolled = false;
            }
          });
        },
        { rootMargin: '0px', threshold: [0, 1] }
      );

      observer.observe(productFormButtons);

      let ticking = false;
      window.addEventListener('scroll', () => {
        if (!ticking) {
          window.requestAnimationFrame(() => {
            checkScrollPosition();
            ticking = false;
          });
          ticking = true;
        }
      }, { passive: true });

      checkScrollPosition();
    }

    // Handle sticky form submission
    function handleStickyFormSubmit(event) {
      event.preventDefault();
      if (stickySubmitBtn.classList.contains('active') || stickySubmitBtn.disabled) return;

      // Force a sync right before submission
      syncWithMainProduct();

      stickySubmitBtn.classList.add('active');
      const config = {
        method: 'POST',
        headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body: new FormData(stickyForm)
      };

      fetch(`${window.routes?.cart_add_url || '/cart/add'}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            document.dispatchEvent(
              new CustomEvent('theme-cart:updated', {
                detail: { shouldOpenCart: false, error: response.description }
              })
            );
            return;
          } else if (!quickCart) {
            window.location = window.routes?.cart_url || '/cart';
            return;
          }
          document.dispatchEvent(
            new CustomEvent('theme-cart:updated', {
              detail: { shouldOpenCart: true }
            })
          );
        })
        .catch((error) => {
          console.error('Sticky ATC error:', error);
        })
        .finally(() => {
          stickySubmitBtn.classList.remove('active');
        });
    }

    // Click on image or title smoothly scrolls up to product section
    if (stickyContent) {
      stickyContent.addEventListener('click', (e) => {
        if (!e.target.closest('button, a, input, select')) {
          productSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    }

    // Event listeners for variant changes
    document.addEventListener('theme-variant:changed', (event) => {
      if (!event.detail || event.detail.sectionId === productSection.dataset.section || event.detail.sectionId === productSection.id) {
        syncWithMainProduct(event.detail?.variant);
      }
    });

    document.addEventListener('theme-variantOption:changed', (event) => {
      if (!event.detail || event.detail.sectionId === productSection.dataset.section || event.detail.sectionId === productSection.id) {
        // Immediate sync check, and then follow-up sync for network fetch
        syncWithMainProduct();
        setTimeout(syncWithMainProduct, 200);
        setTimeout(syncWithMainProduct, 500);
      }
    });

    document.addEventListener('theme-cart:updated', () => {
      setTimeout(syncWithMainProduct, 100);
    });

    // Mutation observer on product section to catch DOM updates (like morphdom)
    const domObserver = new MutationObserver(() => {
      syncWithMainProduct();
    });

    const targetNodes = [
      productSection.querySelector('[data-update-hidden-id]'),
      productSection.querySelector('[data-selected-variant]'),
      productSection.querySelector('[data-update-buy-buttons]')
    ].filter(Boolean);

    targetNodes.forEach((node) => {
      domObserver.observe(node, {
        attributes: true,
        childList: true,
        characterData: true,
        subtree: true
      });
    });

    // Form submit listener
    if (stickyForm) {
      stickyForm.addEventListener('submit', handleStickyFormSubmit);
    }

    // Initialize scroll observer and run initial sync
    initScrollObserver();
    syncWithMainProduct();
  }

  // Handle re-initialization when switching products via ajax product swatches
  document.addEventListener('ajaxProductSwitch:loaded', () => {
    setTimeout(initStickyAddToCart, 100);
  });

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyAddToCart);
  } else {
    initStickyAddToCart();
  }
})();
